import { render } from "./AboutContainer.vue?vue&type=template&id=6edfac16&scoped=true"
import script from "./AboutContainer.vue?vue&type=script&lang=js"
export * from "./AboutContainer.vue?vue&type=script&lang=js"

import "./AboutContainer.vue?vue&type=style&index=0&id=6edfac16&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6edfac16"]])

export default __exports__